// const initiateRazorpayPayment = (amount, transactionId, userPhone) => {
//   return new Promise((resolve, reject) => {
//     if (!window.Razorpay) {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.async = true;
//       document.body.appendChild(script);

//       script.onload = () => {
//         openRazorpay(amount, transactionId, userPhone, resolve, reject);
//       };

//       script.onerror = () => {
//         reject(new Error("Failed to load Razorpay SDK"));
//       };
//     } else {
//       openRazorpay(amount, transactionId, userPhone, resolve, reject);
//     }
//   });
// };

// const openRazorpay = (amount, transactionId, userPhone, resolve, reject) => {
//   const options = {
//     key: "rzp_test_nIMrXQPUbf1Gy3", // Replace with your Razorpay Key ID
//     amount: amount * 100, // Convert to paise
//     currency: "INR",
//     name: "PS-Stores",
//     webview_intent: true,
//     description: `Payment for #${transactionId}`,
//     handler: function (response) {
//       console.log("Payment successful:", response);
//       resolve(response);
//     },
//     prefill: {
//       contact: userPhone,
//     },
//     theme: {
//       color: "#3f7936",
//     },
//     modal: {
//       escape: false,
//       ondismiss: function () {
//         reject(new Error("Payment cancelled by user"));
//       },
//     },
//   };

//   const paymentObject = new window.Razorpay(options);
//   paymentObject.open();
// };

// export default initiateRazorpayPayment;




// const initiateRazorpayPayment = async (amount, transactionId, userPhone,customOrderId) => {
//   try {
//     // Step 1: Call your backend to create a Razorpay order
//     const res = await fetch("https://us-central1-kabili.cloudfunctions.net/api/create-testorder", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ amount, transactionId, customOrderId  }),
//     });

//     if (!res.ok) throw new Error("Failed to create Razorpay order");
    
//     const orderData = await res.json(); // Contains order.id and other details
//     console.log("Order ID from backend:", orderData.id);

//     // Step 2: Load Razorpay script if not already loaded
//     if (!window.Razorpay) {
//       await loadRazorpayScript();
//     }

//     // Step 3: Open Razorpay checkout
//     return new Promise((resolve, reject) => {
//       openRazorpay(amount, transactionId, userPhone, orderData.id, resolve, reject);
//     });
//   } catch (error) {
//     console.error("Payment initiation failed:", error);
//     throw error;
//   }
// };

// // Utility to load Razorpay SDK
// const loadRazorpayScript = () => {
//   return new Promise((resolve, reject) => {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     script.onload = resolve;
//     script.onerror = () => reject(new Error("Failed to load Razorpay SDK"));
//     document.body.appendChild(script);
//   });
// };

// // Razorpay Checkout Logic
// const openRazorpay = (amount, transactionId, userPhone, orderId, resolve, reject) => {
//   const options = {
//     key: "rzp_test_RiJS8IGnFFrEKT", // Replace with your Razorpay Key ID
//     amount: amount * 100,
//     currency: "INR",
//     name: "Kabili Holidays",
//     webview_intent: true,
//     description: `Payment for #${transactionId}`,
//     order_id: orderId, // <-- Pass the order ID from backend
    
//     handler: function (response) {
//       console.log("Payment successful:", response);
//       resolve(response);
//     },
//     prefill: {
//       contact: userPhone,
//     },
//     theme: {
//       color: "#54b435",
//     },
//     modal: {
//       escape: false,
//       ondismiss: function () {
//         reject(new Error("Payment cancelled by user"));
//       },
//     },
//   };

//   const rzp = new window.Razorpay(options);
//   rzp.open();
// };

// export default initiateRazorpayPayment;

const initiateRazorpayPayment = async (amount, transactionId, userPhone,customOrderId) => {
  try {
    // Step 1: Call your backend to create a Razorpay order
    const res = await fetch("https://us-central1-kabili.cloudfunctions.net/api/create-order", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount, transactionId, customOrderId  }),
    });

    if (!res.ok) throw new Error("Failed to create Razorpay order");
    
    const orderData = await res.json(); // Contains order.id and other details
    console.log("Order ID from backend:", orderData.id);

    // Step 2: Load Razorpay script if not already loaded
    if (!window.Razorpay) {
      await loadRazorpayScript();
    }

    // Step 3: Open Razorpay checkout
    return new Promise((resolve, reject) => {
      openRazorpay(amount, transactionId, userPhone, orderData.id, resolve, reject);
    });
  } catch (error) {
    console.error("Payment initiation failed:", error);
    throw error;
  }
};

// Utility to load Razorpay SDK
const loadRazorpayScript = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error("Failed to load Razorpay SDK"));
    document.body.appendChild(script);
  });
};

// Razorpay Checkout Logic
const openRazorpay = (amount, transactionId, userPhone, orderId, resolve, reject) => {
  const options = {
    key: "rzp_live_RW2TekTORTReQg", // Replace with your Razorpay Key ID
    amount: amount * 100,
    currency: "INR",
    name: "Kabili Holidays",
    webview_intent: true,
    description: `Payment for #${transactionId}`,
    order_id: orderId, // <-- Pass the order ID from backend
    
    handler: function (response) {
      console.log("Payment successful:", response);
      resolve(response);
    },
    prefill: {
      contact: userPhone,
    },
    theme: {
      color: "#54b435",
    },
    modal: {
      escape: false,
      ondismiss: function () {
        reject(new Error("Payment cancelled by user"));
      },
    },
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
};

export default initiateRazorpayPayment;